import { getAggregateError, } from "@bracket/catch";
import { contract, multiCaller, } from "@bracket/chainography/contracts";
import type { EthereumAddress, } from "@bracket/types";
import * as G from "@globals";
import type { LoadedVault, } from "@types";
import { wagmiConfig as config } from "@wagmiconfig";
import { WEI, } from "@bracket/blocksmith";



export declare type GetBalancesProps = {
	wallet: EthereumAddress;
	wrapper: EthereumAddress;
	vault: EthereumAddress;
}



export const getBalances = async ({
	wallet,
	wrapper,
	vault,
}: GetBalancesProps) => {

	const [ [ vault_balance, wrapper_balance, ], errors, ] = await multiCaller<[bigint, bigint]>(config, [
		contract("ERC20", "balanceOf", vault, wallet),
		contract("ERC20", "balanceOf", wrapper, wallet),
	]);

	if(errors) {
		throw getAggregateError(errors, `Wrap:Resolvers::getBalances failed to get balances of wallet "${wallet}" or wrapper "${wrapper}"`);
	}

	return {
		wrapper_balance,
		vault_balance,
	}

}

export const applyBalances = async ( vault: LoadedVault, ): Promise<LoadedVault> => {

	const { address, anonymous, } = G.wallet.getBracketWallet();

	if(anonymous || !vault.wrapper) {
		return {
			...vault,
			vaultBalance: null,
			wrapperBalance: null,
		}
	}

	const { vault_balance, wrapper_balance, } = await getBalances({
		wallet: address,
		wrapper: vault.wrapper.address,
		vault: vault.address,
	});

	return {
		...vault,
		vaultBalance: await WEI.from(vault_balance, { symbol: vault.symbol, label: vault.symbol, decimals: vault.denomination.decimals, }),
		wrapperBalance: await WEI.from(wrapper_balance, { symbol: vault.wrapper.symbol, label: vault.wrapper.symbol, decimals: vault.denomination.decimals, }),
	}

}
